import React from 'react';
import MeanKitty from './meankitty';

function App() {
  return (
    <MeanKitty />
  )
}

export default App;
